module.exports = __webpack_public_path__ + "static/media/banner-mob.dd050974.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/banner-mob.png
// module id = 39
// module chunks = 0